module.exports = __webpack_public_path__ + "img/photo8.677e3b5e.jpg";